import type { components } from "@/lib/api/schema.gen";

export type CatalogueItem = components["schemas"]["CatalogueItem"];
export type FlagRequest = components["schemas"]["FlagRequest"];
export type ImpactLine = components["schemas"]["ImpactLine"];
export type Impact = components["schemas"]["Impact"];
export type Blocker = components["schemas"]["Blocker"];

/** The API's kind keys (``questionnaire_definition.content.KINDS``). */
export type CatalogueKind =
  | "thematic"
  | "issue"
  | "goal"
  | "action"
  | "sector"
  | "sector_category"
  | "characteristic"
  | "characteristic_group";

/** The staged flags (``api.views.catalogue.FLAGS``). */
export type FlagKey = "expert-access" | "demo";

/** The page's tabs, in the order both apps list them. */
export const CATALOGUE_TABS = [
  "thematics",
  "issues",
  "goals",
  "actions",
  "sectors",
  "characteristics",
] as const;
export type CatalogueTab = (typeof CATALOGUE_TABS)[number];

/** A write body: any subset of the kind's form fields. */
export type CatalogueWrite = components["schemas"]["CatalogueWrite"];
